export default __webpack_public_path__ + "static/media/s-right.4956048c.png";